import { t } from "i18next";
import React from "react";

import { NavigationSubMenuItem } from "./navigation-sub-menu-item/NavigationSubMenuItem";
import { useIsChildRouteEnabled } from "components/navigation/hooks/useIsChildRouteEnabled";
import { useIsRouteEnabled } from "components/navigation/hooks/useIsRouteEnabled";
import { NavigationLabel } from "components/navigation/navigation-panel/sub-navigation-panel/ui-components/navigation-label/NavigationLabel";
import { NavigationSubSection } from "components/navigation/navigation-panel/sub-navigation-panel/ui-components/navigation-sub-section/NavigationSubSection";
import { RouteDefinition } from "components/router/Routes";

interface Props {
    mainRoute: RouteDefinition;
}

export const DashboardSubmenu = (props: Props) => {
    const isRouteEnabled = useIsRouteEnabled();
    const { isChildRouteEnabled, isChildRouteAdvertised } = useIsChildRouteEnabled();

    if (!props.mainRoute || !isRouteEnabled(props.mainRoute)) {
        return null;
    }

    const [CUSTOM_DASHBOARD_OVERVIEW, SUSTAINABILITY_DASHBOARD_ROUTE] = props.mainRoute.childRoutes;

    return (
        <>
            {isChildRouteEnabled(CUSTOM_DASHBOARD_OVERVIEW) && (
                <>
                    <NavigationSubMenuItem
                        to={CUSTOM_DASHBOARD_OVERVIEW.path}
                        isAdvertised={isChildRouteAdvertised(CUSTOM_DASHBOARD_OVERVIEW)}
                        testId={CUSTOM_DASHBOARD_OVERVIEW.testId}
                    >
                        {t("Routes.dashboard")}
                    </NavigationSubMenuItem>
                </>
            )}
            {isChildRouteEnabled(SUSTAINABILITY_DASHBOARD_ROUTE) && (
                <>
                    <NavigationLabel>{t("Routes.esgDashboard")}</NavigationLabel>

                    <NavigationSubSection>
                        {SUSTAINABILITY_DASHBOARD_ROUTE.childRoutes.map((route) => {
                            return (
                                isChildRouteEnabled(route) && (
                                    <NavigationSubMenuItem
                                        key={route.path}
                                        to={route.path}
                                        isAdvertised={isChildRouteAdvertised(route)}
                                        testId={route.testId}
                                    >
                                        {t(route.title)}
                                    </NavigationSubMenuItem>
                                )
                            );
                        })}
                    </NavigationSubSection>
                </>
            )}
        </>
    );
};
